const VERSION = '2.0.5a'
export default VERSION
